var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-title"},[_c('v-icon',{staticClass:"title-icon",attrs:{"size":"15"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }